<template lang="pug">
  div
    .form-row
      .col-6
        .form-group
          label(for="state" :required="stateRequired") State
          CustomSelect(
            :options="userStates"
            label-name="name"
            value-name="abbreviation"
            id-value="state"
            :value="selectedState"
            @input="$emit('update:selectedState', $event)"
            :invalid="!stateValid"
          )
          FormError(v-show="!stateValid") State is required.
    .form-row
      .col
        .form-group
          label(for="agency" :required="agencyRequired") User Agency
          SuperSelect(
            taggable
            :options="agencies"
            label-name="full_description"
            :value="selectedAgencies"
            valueName="id"
            @input="$emit('update:selectedAgencies', $event)"
            @filter="name = $event"
            :valid="agencyValid"
          )
          FormError(v-show="!agencyValid") Agency is required.
</template>

<script>
import {
  agencyAdmin,
  stateAdmin,
  internalAdmin,
} from '@/lib/plugins/authorization'
import axios from '@/lib/axios'
import CustomSelect from '@/components/CustomSelect'
import debounce from '@/lib/debounce'
import FormError from '@/components/FormError'
import states from '@/lib/states'
import store from '@/store'
import SuperSelect from '@/components/SuperSelect'

function getAgencies(name = '', state = '') {
  if (internalAdmin()) {
    return axios().get('/api/misc/agencies', { params: { name, state } })
  } else if (stateAdmin()) {
    return axios().get('/api/misc/agencies', { params: { state, name } })
  } else if (agencyAdmin()) {
    let ids = store.state.account.agencies.join(',')
    return axios().get('/api/misc/agencies', { params: { ids, name, state } })
  }
}

export default {
  name: 'AgencySelector',
  props: {
    selectedAgencies: {
      type: Array,
      default: () => [],
    },
    selectedState: {
      type: String,
      default: '',
    },
    stateRequired: {
      type: Boolean,
      default: false,
    },
    stateValid: {
      type: Boolean,
      default: false,
    },
    agencyRequired: {
      type: Boolean,
      default: false,
    },
    agencyValid: {
      type: Boolean,
      default: true,
    },
    invalidMessages: {
      type: Boolean,
      default: false,
    },
    // Prevent the app from clearing out agencies if the state changes
    resetAgenciesOnStateChange: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      entries: states,
      agencies: [],
      internalSelected: [...this.selectedAgencies],
      state: '',
      name: '',
      agencyFilter: debounce(
        (name, state) => this.filterQuery(name, state),
        250,
      ),
    }
  },
  methods: {
    filterQuery(name, state) {
      if (!state) {
        this.agencies = []
        return
      }
      getAgencies(name, state).then(resp => (this.agencies = resp.data))
    },
  },
  computed: {
    userStates() {
      let us = this.$store.state.account.states
      if (this.$auth.internalAdmin()) {
        return states
      } else {
        return states.filter(st => us.includes(st.abbreviation))
      }
    },
    agencyNames() {
      if (!this.state) return []
      return this.agencies.map(a => a.name)
    },
  },
  watch: {
    internalSelected(val) {
      this.$emit('update:selectedAgencies', val)
    },
    selectedState() {
      if (this.resetAgenciesOnStateChange)
        this.$emit('update:selectedAgencies', []) // Deselect all agencies if the state changes
      if (this.selectedState === '') {
        this.agencies = []
        return
      }
      this.agencyFilter(this.name, this.selectedState)
    },
    name() {
      this.agencyFilter(this.name, this.selectedState)
    },
  },
  components: { CustomSelect, SuperSelect, FormError },
}
</script>

<style lang="scss" scoped>
</style>
